import { distinctUntilChanged, MonoTypeOperatorFunction } from 'rxjs';

/**
 * Uses JSON.stringify while values of null, undefined, empty string or empty array are treated as undefined.
 *
 * Values of type array are filtered (remove null, undefined, empty string elements) and after that,
 * while of length one, are treated as value of this single array element.
 *
 * @param filterObject object holding actual filter values
 */
export const stringifyFilterObject = (filterObject: any): string => {
    const nullOrEmptyToUndefined = (value: any): any => value === null || value === '' ? undefined : value;
    return JSON.stringify(
        filterObject,
        (_, value) => {
            if (Array.isArray(value)) {
                const array = value.filter(item => nullOrEmptyToUndefined(item) !== undefined);
                if (array.length) {
                    if (array.length === 1) {
                        value = array[0];
                    } else {
                        value = array;
                    }
                } else {
                    value = undefined;
                }
            }
            return nullOrEmptyToUndefined(value);
        },
    );
};

export const distinctUntilFilterChanged = <T>(): MonoTypeOperatorFunction<T> => {
    return source$ =>
        source$.pipe(
            distinctUntilChanged((prev, curr) => stringifyFilterObject(prev) === stringifyFilterObject(curr)),
        );
};
